import { createAction } from '@reduxjs/toolkit';
export const REJECT_CALL = 'REJECT_CALL';
export const rejectCallAction = createAction(REJECT_CALL);